module.exports = __webpack_public_path__ + "img/play-button.f1746e38.png";